import React, { useRef, useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { reqMobileCertificate } from '@store/actions/userAction';
import {
  showModal,
  confirmModal,
  cancelModal,
} from '@store/actions/commonAction';

import { toPhoneNumber } from '@common/utils/index';
import { setReceiveKeyEventOnOff } from '@common/utils/device';

import LoginTelAgree from '@container/login/LoginTelAgree';

import SatModal from '@components/common/satUI/SatModal';
import SatNumberKeypad from '@components/common/satUI/SatNumberKeypad';

const LoginAuthConfirm = () => {
  const inputRef = useRef();

  const {
    loginInfo: {
      device: { applicationDeviceCode },
    },
  } = useSelector(state => state.userReducer);
  const isDeviceTablet = applicationDeviceCode === '02';

  const history = useHistory();
  const dispatch = useDispatch();

  const [tel, setTel] = useState('');
  const [telecom, setTelecom] = useState([
    { name: 'SKT', id: 'mobile_g1', checked: false, value: 'SKT' },
    { name: 'KT', id: 'mobile_g2', checked: false, value: 'KTF' },
    { name: 'LG U+', id: 'mobile_g3', checked: false, value: 'LGT' },
    { name: 'SK알뜰폰', id: 'mobile_g4', checked: false, value: 'SKM' },
    { name: 'KT알뜰폰', id: 'mobile_g5', checked: false, value: 'KTM' },
    { name: 'LG알뜰폰', id: 'mobile_g6', checked: false, value: 'LGM' },
  ]);
  const [agree, setAgree] = useState(false);
  const [isOpenAgreeTerm, setIsOpenAgreeTerm] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  /**
   * 휴대전화 input change Event
   * @param {Event} e
   */
  const onInputChangeHandler = e => {
    setTel(toPhoneNumber(e.target.value));
  };
  /**
   * 통신사 라디오버튼 change Event
   * @param {Event} e
   */
  const onRadioChnageHandler = e => {
    const { id } = e.target;

    setTelecom(
      telecom.map(item => {
        return id === item.id
          ? { ...item, checked: true }
          : { ...item, checked: false };
      }),
    );
  };
  /**
   * 약관동의 change Event
   * @param {Event} e
   */
  const onCheckAgreeHandler = e => {
    setAgree(e.target.checked);
  };
  /**
   * '인증번호받기' click Event
   */
  const onButtonClickHandler = () => {
    const validation = () => {
      const reg = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;

      if (tel.trim() === '') {
        setError(true);
        return {
          result: false,
          error: true,
          //   msg: '휴대전화번호를 입력해주세요.',
          //   onOk: {
          //     handle: () => inputRef.current.focus(),
          //   },
        };
      } else if (!reg.test(tel)) {
        return {
          result: false,
          msg: '휴대전화번호를 확인해주세요.',
          onOk: {
            handle: () => inputRef.current.focus(),
          },
        };
      }

      if (telecom.filter(item => item.checked === true).length !== 1) {
        return {
          result: false,
          msg: '통신사를 선택해주세요.',
        };
      }

      if (!agree) {
        return {
          result: false,
          msg: '약관동의를 체크해주세요.',
        };
      }

      return {
        result: true,
      };
    };

    const { result, msg, onOk, error } = validation();

    if (result) {
      dispatch(
        reqMobileCertificate({
          hpcorp: telecom.filter(item => item.checked === true)[0].value,
          mobileNo: tel,
        }),
      );
      // history.push('/login/authorization');
    } else {
      if (error) return;
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: msg,
          onOk: onOk,
        }),
      );
    }
  };

  const onTelAgreeClick = () => {
    if (telecom.filter(item => item.checked === true).length !== 1) {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '통신사를 선택해주세요.',
        }),
      );
      return;
    }

    setIsOpenAgreeTerm(true);
  };

  const onFocusHandler = e => {
    const target = e.target;
    const { value } = target;

    if (isDeviceTablet) {
      window.addEventListener(
        'setReceiveKeyEventOnOffCallBack',
        setReceiveKeyEventOnOffCallBack,
        false,
      );
      setReceiveKeyEventOnOff(true);
      showNumberKeypad({ value });
    }

    target.blur();
    setIsFocused(true);
  };

  const keypadRef = useRef();
  const setReceiveKeyEventOnOffCallBack = ({ data: { isOn } }) => {
    if (isOn) {
      window.addEventListener('receiveKeyEvent', receiveKeyEvent, false);
    }
  };

  const onAfterCloseKeypad = () => {
    if (isDeviceTablet) {
      window.removeEventListener(
        'setReceiveKeyEventOnOffCallBack',
        setReceiveKeyEventOnOffCallBack,
        false,
      );
      window.removeEventListener('receiveKeyEvent', receiveKeyEvent, false);
      setReceiveKeyEventOnOff(false);
    }

    setIsFocused(false);
  };

  const closeNumberKeypad = () => {
    dispatch(cancelModal(onAfterCloseKeypad));
  };

  const showNumberKeypad = ({ value }) => {
    dispatch(
      showModal({
        visible: true,
        type: 'slide',
        render: () => (
          <SatNumberKeypad
            ref={keypadRef}
            type={'number'}
            title={'휴대전화번호'}
            numValue={value}
            validGuide={''}
            maxLength={'11'}
            useMobile={true}
            onOk={value => handleNumberKeypadComplete(value)}
            onClose={closeNumberKeypad}
          />
        ),
        setVisible: closeNumberKeypad,
      }),
    );
  };

  const handleNumberKeypadComplete = value => {
    setTel(toPhoneNumber(value.replace(/[^0-9]/gi, '')));

    dispatch(confirmModal(onAfterCloseKeypad));
  };
  const receiveKeyEvent = ({ data }) => {
    if (keypadRef && keypadRef.current) {
      keypadRef.current.setInputKeyEvent(data);
    }
  };

  return (
    <>
      <div className="page-navi">
        <button
          type="button"
          className="btn-back"
          onClick={() => history.goBack()}
        >
          <span className="hide">이전</span>
        </button>
      </div>
      <h3 className="tit-con">동의를 위한 본인 인증</h3>
      <p className="text-con">본인 명의의 휴대폰 정보를 입력해 주세요.</p>

      <div className="logincon-area">
        <div className="login-form">
          <div className={`input-wrap val ${isFocused ? 'focus' : ''}`}>
            <div className="input-area">
              <label htmlFor="num" className="input-tit">
                휴대전화 번호
              </label>
              <input
                ref={inputRef}
                className="input"
                type="text"
                value={tel}
                placeholder="숫자만 입력하세요."
                onChange={onInputChangeHandler}
                onFocus={onFocusHandler}
              />
            </div>
          </div>
          {error && tel.length === 0 ? (
            <p className="text-info ico-type error">
              휴대전화번호를 입력해주세요.
            </p>
          ) : (
            ''
          )}
          <div className="btn-group col3">
            <div className="check-wrap type-btn">
              <input
                type="radio"
                id="mobile_g1"
                name="mobile"
                onChange={onRadioChnageHandler}
              />
              <label htmlFor="mobile_g1">SKT</label>
            </div>
            <div className="check-wrap type-btn">
              <input
                type="radio"
                id="mobile_g2"
                name="mobile"
                onChange={onRadioChnageHandler}
              />
              <label htmlFor="mobile_g2">KT</label>
            </div>
            <div className="check-wrap type-btn">
              <input
                type="radio"
                id="mobile_g3"
                name="mobile"
                onChange={onRadioChnageHandler}
              />
              <label htmlFor="mobile_g3">LG U+</label>
            </div>
            <div className="check-wrap type-btn">
              <input
                type="radio"
                id="mobile_g4"
                name="mobile"
                onChange={onRadioChnageHandler}
              />
              <label htmlFor="mobile_g4">SK 알뜰폰</label>
            </div>
            <div className="check-wrap type-btn">
              <input
                type="radio"
                id="mobile_g5"
                name="mobile"
                onChange={onRadioChnageHandler}
              />
              <label htmlFor="mobile_g5">KT 알뜰폰</label>
            </div>
            <div className="check-wrap type-btn">
              <input
                type="radio"
                id="mobile_g6"
                name="mobile"
                onChange={onRadioChnageHandler}
              />
              <label htmlFor="mobile_g6">LG 알뜰폰</label>
            </div>
          </div>
          <div className="agree-list">
            <div className="tit-area">
              <div className="check-wrap default">
                <input
                  type="checkbox"
                  name="radioAll"
                  id="radioAll"
                  onChange={onCheckAgreeHandler}
                />
                <label htmlFor="radioAll">모두 동의합니다.</label>
              </div>
              <button
                type="button"
                className="btn-view"
                onClick={onTelAgreeClick}
              >
                전문보기
              </button>
            </div>
            <ul className="list-block">
              <li>개인정보 수집/이용 동의</li>
              <li>고유식별정보 처리 동의</li>
              <li>서비스 이용약관 동의</li>
              <li>통신사 이용약관 동의</li>
              <li>알뜰폰 제3자 제공 동의</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="btn-area">
        <button
          type="button"
          className="btn-l blue"
          onClick={onButtonClickHandler}
        >
          인증번호 받기
        </button>
      </div>

      <SatModal visible={isOpenAgreeTerm} type="fullPop">
        <LoginTelAgree
          telType={telecom.filter(item => item.checked === true)[0]?.name}
          setIsOpenAgreeTerm={setIsOpenAgreeTerm}
        />
      </SatModal>
    </>
  );
};

export default LoginAuthConfirm;
